import React from 'react';
import { Button, SparkIcon, Text } from '@spark';

/**
 * Top header of the Inference & Monitoring tab.
 * Shows the section title and three action buttons.
 */
const InferenceHeader = ({ onUpgradeToGpu, onApiDocs, onInferenceEndpoint }) => (
    <div className="inference-header">
        <Text variant="heading-5-semibold" color="primary" as="p">Inference</Text>
        <div className="inference-header__actions">
            <Button
                variant="tertiary"
                size="medium"
                startIcon={<SparkIcon slug="bolt" size="medium" />}
                onClick={onUpgradeToGpu}
            >
                Upgrade to GPU
            </Button>
            <Button
                variant="tertiary"
                size="medium"
                startIcon={<SparkIcon slug="book" size="medium" />}
                onClick={onApiDocs}
            >
                API Documentation
            </Button>
            <Button
                variant="tertiary"
                size="medium"
                startIcon={<SparkIcon slug="endpoint" size="medium" />}
                onClick={onInferenceEndpoint}
            >
                Inference Endpoint
            </Button>
        </div>
    </div>
);

export default InferenceHeader;
